<template>
  <ol v-if="!noMainMenuFromV4" class="breadcrumb" :class="{ 'breadcrumb--ml': !mainMenuIsOpen }">
    <li class="breadcrumb-item">
      <router-link :to="{ name: 'Home' }" :title="$t('Common.initialPage')">
        <v-icon color="gray-6">home</v-icon>
      </router-link>
    </li>

    <li
      v-for="(route, index) in routes"
      :key="`item${index}`"
      class="breadcrumb-item"
      :class="{ 'breadcrumb-item--active': currentRouteName === route.name }"
    >
      <v-icon>keyboard_arrow_right</v-icon>
      <span
        v-if="currentRouteName === route.name || !route.name"
        :title="route.title"
      >
        {{ route.title | ellipsis(35) }}
      </span>
      <router-link v-else :to="{ name: route.name }" :title="route.title">
        {{ route.title }}
      </router-link>
    </li>
  </ol>
  <ol v-else class="breadcrumb" :class="{ 'breadcrumb--ml': !mainMenuIsOpen }">
    <li class="breadcrumb-item">
      <router-link :to="{ name: 'Home' }" :title="$t('Common.initialPage')">
        <span>
     {{ $t('Views.HomePage.title') }}
        </span>
      </router-link>
    </li>

    <li
      v-for="(route, index) in routes"
      :key="`item${index}`"
      class="breadcrumb-item"
    >
      <span class="breadcrumb-connector">
        /
      </span>
      <span
        v-if="currentRouteName === route.name || !route.name"
        :title="route.title"
        :class="{ 'breadcrumb-item--active': currentRouteName === route.name }"
      >
        {{ route.title | ellipsis(35) }}
      </span>
      <router-link v-else :to="{ name: route.name }" :title="route.title" :class="{ 'breadcrumb-item--active': currentRouteName === route.name }">
        {{ route.title }}
      </router-link>
    </li>
  </ol>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Breadcrumb',
  props: {
    routes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen,
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    }),

    currentRouteName () {
      return this.$route.name
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: none;
  list-style-type: none;
  margin-left: 0;
  padding-left: 0;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  @media (min-width: 768px) {
    display: block;
  }

  &.breadcrumb--ml {
    margin-left: 0;

    @media (min-width: 768px) {
      margin-left: 100px;
    }
  }
}

.breadcrumb-item {
  display: inline-block;
  vertical-align: middle;

  &:first-child {

    .v-icon {
      font-size: 16px;
      line-height: 1;
      position: relative;
      top: -1px;
    }
  }

  a, .v-icon {
    display: inline-block;
    vertical-align: middle;
  }

  a {
    color: $gray-7;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-icon {
    font-size: 20px;
    opacity: .6;
  }
}

.breadcrumb-item--active {
  font-weight: 600;
}

.no-main-menu-from-v4 {
  .breadcrumb {
    font-size: 14px;

    .breadcrumb-connector {
      width: 7px;
      margin: 0 8px;
      color: #595C66;
    }
    .breadcrumb-item {
      color: #8D9099;
    }
    a {
      color: #8D9099;
      transition: 0.2s;
      &:hover {
        color: #282B33;
        transition: 0.2s;
      }
    }
    .breadcrumb-item--active {
      color: #282B33;
      font-weight: 400;
    }
  }
}
</style>
